import { useValueListener } from "@jasperlabs/hooks";

import { useSession } from "./session";

/**
 * Listens to whether the user's session changes.
 * Runs on sign in, sign out or session refresh.
 *
 * @param {(change: { previous: string, value: string }) => void} onSessionChanged
 *   Receives the token the session changed from and the one it changed to.
 */
const useSessionOnChange = (onSessionChanged = () => {}) => {
	const { sessionToken } = useSession();

	useValueListener({
		value: sessionToken,
		onChange: onSessionChanged,
	});
};

export default useSessionOnChange;
